import React, { Fragment } from 'react';
import { LOCField } from './BasicComponents';

export const PayerLOC = (props) => (
  <Fragment>
    <LOCField {...props} />
  </Fragment>
);
